import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import scenarioReducer from './slices/scenarioSlice';
import flowReducer from './slices/flowSlice';
import executionReducer from './slices/executionSlice';
import billingReducer from './slices/billingSlice';
import facebookReducer from './slices/facebookSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    scenarios: scenarioReducer,
    flow: flowReducer,
    executions: executionReducer,
    billing: billingReducer,
    facebook: facebookReducer,
  },
});
